module.exports = __webpack_public_path__ + "static/media/file.a23c306a.svg";